import { PDF_DPI } from "common/constants/pdfSettings";
import type { SheetInches, SheetPoints } from "common/types/nominalNumbersTypes";

/**
 * The rounding factor is applied to each path element and rounds to 1 / ROUNDING_FACTOR.
 * PDF works in points, which are 1/72 of an inch. So, a rounding factor of 10 rounds
 * our drawings to 1/720th of an inch.
 */
const PDF_POINT_ROUNDING_FACTOR = 10;
const PDF_INCH_ROUNDING_FACTOR = PDF_POINT_ROUNDING_FACTOR * PDF_DPI;
const PDF_WRAP_COMPARISON_ROUNDING_FACTOR = 1e4;

export function roundPDFPoints(x: SheetPoints): SheetPoints {
  return (Math.round(x * PDF_POINT_ROUNDING_FACTOR) / PDF_POINT_ROUNDING_FACTOR) as SheetPoints;
}

export function roundUpPDFPoints(x: SheetPoints): SheetPoints {
  return (Math.round(x * PDF_POINT_ROUNDING_FACTOR + 0.5) / PDF_POINT_ROUNDING_FACTOR) as SheetPoints;
}

/**
 * TODO: We should decide if we need to keep this rounding code or remove it.
 * @deprecated
 */
export function roundPDFInches(x: SheetInches): SheetInches {
  return (Math.round(x * PDF_INCH_ROUNDING_FACTOR) / PDF_INCH_ROUNDING_FACTOR) as SheetInches;
}

/**
 * @deprecated
 */
export function roundUpPDFInches(x: SheetInches): SheetInches {
  return (Math.round(x * PDF_INCH_ROUNDING_FACTOR + 0.5) / PDF_INCH_ROUNDING_FACTOR) as SheetInches;
}

export function roundPDFWrapComparisonInches(x: SheetInches): SheetInches {
  return (Math.round(x * PDF_WRAP_COMPARISON_ROUNDING_FACTOR) / PDF_WRAP_COMPARISON_ROUNDING_FACTOR) as SheetInches;
}
